import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Pill = ({ classes, label, type, addMargin }) => {
  return <span className={cx(classes.pill, classes[type], addMargin && classes.addMargin)}>{label}</span>;
};

Pill.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  label: PropTypes.string,
  type: PropTypes.string,
  addMargin: PropTypes.bool,
};

Pill.defaultProps = {
  classes: {},
  type: 'info',
  addMargin: false,
};

export default Pill;
